export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGOUT_REQUEST = "auth/LOGOUT_REQUEST";
export const TEST_LOAD_SUCCESS = "public/TEST_LOAD_SUCCESS";
export const REPLACE_TEST_ENTRIES = "public/REPLACE_TEST_ENTRIES";
export const UPDATE_TEST_ENTRIES_SUCCESS = "public/UPDATE_TEST_ENTRIES_SUCCESS";
export const UPDATE_CURRENT_SESSION_TEST_DATA =
  "public/UPDATE_CURRENT_SESSION_TEST_DATA";
export const SET_SELECTED_CLIENT_ID = "SET_SELECTED_CLIENT_ID";
